<template>
  <div class="odd:bg-gray-100 border border-gray-200 rounded px-4 flex-1">
    <div class="flex -mx-4 justify-between items-center">
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="flex-1 px-4">
            <h5 class="text-sm">
              {{ accountSubscription.name }}
            </h5>
          </div>

          <div class="w-48 px-4 mt-4 lg:mt-0">
            {{ dateStart }}
          </div>

          <div class="hidden lg:block w-48 lg:text-right px-4">
            {{ accountSubscription.dateCreated }}
          </div>
        </div>
      </div>

      <div class="flex-none pr-4">
        <button
          :disabled="!accountSubscription.can.view || disabled"
          class="w-10 h-10 px-4 py-2 rounded text-blue-600 hover:bg-blue-600 hover:text-white focus:outline-none disabled:text-gray-600 disabled:bg-transparent"
          @click="$emit('account-subscription:view', accountSubscription)"
        >
          <FontAwesomeIcon icon="chevron-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    accountSubscription: { type: Object, required: true },
    disabled: Boolean,
  },

  computed: {
    dateStart() {
      return moment(this.accountSubscription.dateStart).format('DD/MM/YYYY');
    },
  },
};
</script>
